/**
 *  global application constants
 * 
 *  WARNING: these values must match server side constants in corresponding model classes
 */

/* customer type constants */
export const CustomerType = Object.freeze({
  PROVIDER_CUSTOMER: 1
});

export const Role = Object.freeze({
  PROVIDER: 2
});
 
 /* document type constants */
 export const DocumentType = Object.freeze({
    LWC_FORM_1010: 1,
    LWC_FORM_1010A_RESPONSE: 2,
    LWC_FORM_1009: 3,
    LWC_FORM_1008: 4,
    EDI_837: 5,
    CMS_1500: 6,
    COVER_SHEET: 7,
    OTHER_ATTACHMENT: 14,
    INBOUND_FAX: 15,
    LWC_FORM_1010_RESPONSE: 16,
    REMITTANCE: 17,
    LWC_FORM_1010A: 18,
    OTHER: 19,
    LWC_FORM_1009_RESPONSE: 20,
    OFFICE_NOTES: 21,
    CORRESPONDENCE: 22,
    LWC_FORM_1009_DISPUTE_SUMMARY: 23,
    LWC_FORM_1008_FINAL: 24,
    CMS_1450: 25,
    CMS_FORM: 26
 });

 // document status constants
 export const DocumentStatus = Object.freeze({
   AUTHORIZATION_SUBMITTING: -1,
   AUTHORIZATION_SUBMIT_FAILED: -2,
   AUTHORIZATION_NEW: 0,
   AUTHORIZATION_SUBMITTED: 1,
   AUTHORIZATION_ADDITIONAL_INFO_REQUESTED: 2,
   AUTHORIZATION_APPROVED: 3,
   AUTHORIZATION_APPROVED_WITH_MODIFICATIONS: 4,
   AUTHORIZATION_DENIED: 5,
   AUTHORIZATION_RESPONSE_OVERDUE: 6,
   AUTHORIZATION_DISPUTED: 7,

   AUTHORIZATION_DISPUTE_SUBMITTING: -200,
   AUTHORIZATION_DISPUTE_SUBMIT_FAILED: -201,
   AUTHORIZATION_DISPUTE_NEW: 200,
   AUTHORIZATION_DISPUTE_SUBMITTED: 201,
   AUTHORIZATION_DISPUTE_APPROVED: 202,
   AUTHORIZATION_DISPUTE_DENIED: 203,
   AUTHORIZATION_DISPUTE_RESPONSE_OVERDUE: 204,

   CLAIM_SUBMITTING: -100,
   CLAIM_SUBMIT_FAILED: -101,
   CLAIM_NEW: 100,
   CLAIM_SUBMITTED: 101,
   CLAIM_PAID: 102,
   CLAIM_UNDERPAID: 103,
   CLAIM_OVERPAID: 104,
   CLAIM_PAYMENT_OVERDUE: 105,
   CLAIM_DISPUTED: 106,
   
   GENERIC_DOCUMENT_TRANSMISSION_FAILED: -301,
   GENERIC_DOCUMENT_TRANSMITTING: -300,
   GENERIC_DOCUMENT_TRANSMITTED: 300,
   
   ADDITIONAL_INFORMATION_REQUEST_PENDING: 500,
   ADDITIONAL_INFORMATION_RESPONSE_OVERDUE: 501
 });

 // fax status constants - TODO: no longer needed?
 export const FaxStatus = Object.freeze({
   PREPROCESSING: -1,
   DOCUMENT_SENT: 0,
   OUT_OF_CREDIT: -22,
 });

  // association type constants
  export const AssociationType = Object.freeze({
    CLAIM: 1,
    DOCUMENT: 2
  });

  // secure email status constants
  export const EmailStatus = Object.freeze({
    PREPROCESSING: -1,
    SENT: 0,
    DOWNLOADED: 1,
    CONFIRMED: 2,
    EXPIRED: -3,
    ERROR: -4
  });

  // mailed status constants
  export const MailedStatus = Object.freeze({
    MAILED: 1,
    RECEIVED: 2
  });

  // transmission type constants
  export const TransmissionType = Object.freeze({
    SUBMIT: 1,
    SHARE: 2
  });

  // transmission status code constants
  export const TransmissionStatus = Object.freeze({
    IN_PROGRESS: -1,
    SUCCESS: 1,
    FAILURE: 2,
    WARNING: 3
  });

  // transmission method constants
  export const TransmissionMethod = Object.freeze({
    FAX: 1,
    EMAIL: 2,
    MAILED: 3
  });

  // attorney type constants
  export const AttorneyType = Object.freeze({
    EMPLOYEE_ATTORNEY: 1,
    EMPLOYER_ATTORNEY: 2
  });

  // workers compensation time limit constants
  export const TimeLimits = Object.freeze({
    HEALTH_CLAIM_PAYMENT_TIME_LIMIT_DAYS: 60,
  });

  // view historical documents state constants
  export const HistoricalState = Object.freeze({
    NONE: 0,
    ONLY: 1,
    ALL: 2
  });

  export const ContractDisclaimer = 'Estimated reimbursement does not reflect terms of the associated payer contract.';

  export const NoPriorAuthorizationReason = Object.freeze({
    OTHER: 3
  });

  export const ProcessingStatus = Object.freeze({
    Processing: -1,
    Failed: 0,
    Succeeded: 1,
    Duplicate: 2,
    Partial: 3
  });
